// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Jeremias (Jeremiah)",
  bookSlug: "jeremias",
  chapter: 45,
  argument: "The prophet comforts Baruch in his affliction.",
  verses: [
    { n: 1, text: "The word that Jeremias, the prophet, spoke to Baruch, the son of Nerias, when he had written there words in a book, out of the mouth of Jeremias, in the fourth year of Joakim, the son of Josias, king of Juda, saying:" },
    { n: 2, text: "Thus saith the Lord, the God of Israel, to thee, Baruch:" },
    { n: 3, text: "Thou hast said: Woe is me, wretch that I am, for the Lord hath added sorrow to my sorrow; I am wearied with my groans, and I find no rest." },
    { n: 4, text: "Thus saith the Lord: Thus shalt thou say to him: Behold, them whom I have built, I do destroy; and them whom I have planted, I do pluck up, and all this land." },
    { n: 5, text: "And dost thou seek great things for thyself ? Seek not; for behold I will bring evil upon all flesh, saith the Lord: but I will give thee thy life, and save thee in all places whithersoever thou shalt go." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Book, which Joakim burnt, and sought the life of the prophets, chap. xxxvi. (Calmet) — Baruch apprised of the general distress, weeps for it, and his life is spared.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Great: the spirit of prophecy; (Rabbins) or rather to be exempted from suffering, while all the neighbouring nations were perishing. (Calmet) — And save. Literally, \"for salvation.\" Hebrew, \"booty.\" (Haydock) — He seems to have been set at liberty with his master, chap. xl. 1.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
